// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"965660ec","70":"de9d56e7","71":"eb35d3a3","195":"bb08ff7e","213":"8900be79","216":"68ef935c","293":"14f27f33","349":"cd07bf61","360":"19760edb","419":"8ae7d379","606":"a9a5c049","621":"85087160","667":"838751bf","832":"f2ef3127","870":"8c362023"}[chunkId] + ".chunk.js";
};